<template>
     <div>
  
       <!-- <mheader></mheader> -->
        <div v-show="list.length>0" class="card mb-5 p-2" style="width:1300px;margin:0 auto;box-shadow: 10px 10px 5px #888888;" id="v-content" :style="{minHeight:Height+'px'}">
               <p>
                   <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                  </span>
               </p>
              <div v-for="(item,index) in list" :key="index" style="margin-top:100px;">
                    <!-- <p>{{}}</p> -->
                    <div v-html="item.content">
                        {{item.content}}
                    </div>
              </div>

        </div>

      <div>
              <transition name="fade">
                <loading v-if="isLoading"></loading>
              </transition>
      </div>
   <!-- <mfooter></mfooter> -->
  
     </div>
</template>
<script>
// import mheader from '../components/Header.vue'
// import mfooter from '../components/Footer.vue'
import Loading from '../components/Loading.vue'
export default {
  name:'mymessage',
  data(){
    return {
           Height:0,
          isLoading:false,
          list:[]
    }
  },
   components:{
        // mheader,
        // mfooter,
        Loading

    },
    methods:{
     getMR: async function () {
        //  this.isLoading=true;
        const {data: res} = await this.$http.post('http://192.168.1.215:8088/Home/getMR', 
          {groupid:window.sessionStorage.getItem("groupid")}
        )
        // console.log(res)
        if (res.isOk) {
             let that=this;
             that.list=res.mesg;
            //  that.isLoading=false;
             
        }
      },
    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
    created(){
          this.getMR();
            
    }
}
</script>
<style scoped>
.span_close:hover{
       color:#3190e8;
 }
</style>



// WEBPACK FOOTER //
// src/pages/MoreMessage.vue